import { defineStore } from 'pinia'
import type {
  ICreateWarehouseman,
  IWarehouseman,
} from '~/components/warehouseman/types'
import type { TParams } from '~/components/table/types'

export const useWarehouseMan = defineStore('warehouseMan', () => {
  const warehousemanList = ref<IWarehouseman[]>([])

  async function createWarehouseman(data: ICreateWarehouseman) {
    try {
      const response = await useApi('api/admin/warehouseman', {
        method: 'POST',
        body: data,
      })
      if (response.success) {
        return true
      }
    } catch (error) {
      console.error('User creation failed:', error)
      return false
    }
  }

  async function updateWarehouseman(data: IWarehouseman) {
    try {
      const response = await useApi(`api/admin/warehouseman/${data.user_id}`, {
        method: 'PUT',
        body: data,
      })
      if (response.success) {
        return true
      }
    } catch (error) {
      console.error('User creation failed:', error)
      return false
    }
  }

  async function getWarehouseman(id: string) {
    try {
      const response = await useApi(`api/admin/warehouseman/${id}`, {
        method: 'GET',
      })
      if (response.success) {
        return response.data
      }
    } catch (error) {
      console.error('User creation failed:', error)
      return false
    }
  }

  async function getWareHousemanList(params: TParams) {
    try {
      const response = await useApi(`api/admin/warehouseman/${params}`, {
        method: 'GET',
      })
      if (response.success) {
        return (warehousemanList.value = response.data)
      }
    } catch (error) {
      console.error('User creation failed:', error)
      return false
    }
  }

  return {
    createWarehouseman,
    updateWarehouseman,
    getWarehouseman,
    getWareHousemanList,
    warehousemanList,
  }
})
